import { RootState } from 'redux/store';
import { Status } from 'enums/status';
import { StoreFinderWidget } from 'api/stores/types';

export const allStores = (state: RootState): StoreFinderWidget[] =>
  state.stores.data.storeData;

export const allStoresStatus = (state: RootState): Status =>
  state.stores.status;
